import React from "react";

const FooterBottom: React.FC = () => {
  return (
    <div className="border-t border-white/10">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-between gap-3 px-4 py-4 text-sm text-slate-400 sm:px-6 md:flex-row lg:px-8">
        <div className="flex flex-col items-center gap-1 text-center sm:flex-row sm:gap-2 md:text-left">
          <p>© 2026 Nex Computer. All rights reserved.</p>
          <span className="hidden text-slate-600 sm:inline">•</span>
          <span>
            Developed by{" "}
          <a
            href="https://synergeeklabs.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-base font-bold text-indigo-400 transition-colors hover:text-indigo-300"
          >
            Synergeek Labs
          </a>
          </span>
        </div>
        <div className="text-xs">
          <a
            className="transition-colors hover:text-white"
            href="https://store.nexlanka.com/privacy-policy/"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
